import { h, Component } from 'preact';
import { Subject, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

import { Form, FieldList, Field } from '../../../utils/forms/form';
import hopplerLinkState, { hopplerResetForm } from '../../../utils/forms/hoppler-linkstate';

export interface HopplerMultiCheckboxChoice {
  value: string;
  label?: string;
}

interface HopplerMultiCheckboxProps {
  choices: HopplerMultiCheckboxChoice[];
  onChange?: (event: Event) => any;
  valueChange?: (value: string) => any;

  /**
   * Used during component initialization. This does not yet update the widget
   * when changed.
   */
  value?: string;
}

interface HopplerMultiCheckboxState {
  form?: Form;
  selectedValues?: string[];
}

export class HopplerMultiCheckbox extends Component<HopplerMultiCheckboxProps, HopplerMultiCheckboxState> {
  form$: Subject<Form>;
  subscriptions: Subscription[] = [];

  constructor(props) {
    super(props);

    this.setupForm(props);
  }

  componentWillUnmount() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    this.subscriptions = [];
  }

  componentWillReceiveProps(nextProps: HopplerMultiCheckboxProps) {
    if (!nextProps.value) {
      this.setState({ form: hopplerResetForm(this.state.form) })
    }
  }

  getFinalValue(choices: HopplerMultiCheckboxChoice[], form: Form) {
    let selectedValues = [];
    choices.forEach(choice => {
      if (form.fields[choice.value].value) {
        selectedValues.push(choice.value);
      }
    });

    return selectedValues.join(',');
  }

  setupForm(props: HopplerMultiCheckboxProps) {
    let fields: FieldList = {};
    const selectedValues = props.value ? props.value.split(',') : [];
    props.choices.forEach(
      choice => fields[choice.value] = new Field([], null, selectedValues.includes(choice.value))
    );
    console.log(props, fields);

    this.form$ = new Subject<Form>();
    this.setState({ form: new Form(fields) });

    this.subscriptions.push(
      this.form$.pipe(distinctUntilChanged())
        .subscribe(form => {
          this.setState({ form });
          const finalValue = this.getFinalValue(props.choices, this.state.form);

          const changeEvent = {
            target: {
              value: finalValue
            } as any
          } as Event;

          if (props.onChange) {
            props.onChange(changeEvent);
          }
          if (props.valueChange) {
            props.valueChange(finalValue)
          }
        })
    );
  }

  render(props: HopplerMultiCheckboxProps, state: HopplerMultiCheckboxState) {
    return (
      <div className="d-flex">
        {
          props.choices.map(choice => (
            <label className="hi-input-group__checkbox mr-3">
              <input type="checkbox"
                onChange={ hopplerLinkState(this.form$, state.form, choice.value) }
                checked={ state.form.fields[choice.value].value } />
              { choice.label || choice.value }
            </label>
          ))
        }
      </div>
    )
  }
}
